import React, { useState } from 'react';
import styles from './Contacto.module.css';

// ─── CONFIGURACIÓN ────────────────────────────────────────────────────────────
const DATOS = {
  telefono: '(03468) 611074',
  whatsapp: '5493468-611074',
  email: 'yayaperfumayorista@gmail.com',
  direccion: 'Italia 1190, Arias, Córdoba',
  instagram: 'https://www.instagram.com/mayorista.yaya/?hl=es',
};
// ─────────────────────────────────────────────────────────────────────────────

export default function Contacto() {
  const [form, setForm] = useState({ nombre: '', email: '', telefono: '', mensaje: '' });
  const [enviado, setEnviado] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleEnviar = () => {
    if (!form.nombre || !form.mensaje) return;
    const texto = `Hola! Soy *${form.nombre}*.\n\n${form.mensaje}\n\nTeléfono: ${form.telefono || 'No indicado'}\nEmail: ${form.email || 'No indicado'}`;
    window.open(`https://wa.me/${DATOS.whatsapp}?text=${encodeURIComponent(texto)}`, '_blank');
    setEnviado(true);
    setTimeout(() => { setEnviado(false); setForm({ nombre: '', email: '', telefono: '', mensaje: '' }); }, 3000);
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Contacto</h1>
        <p className={styles.subtitle}>¿Tenés alguna consulta? Escribinos y te respondemos a la brevedad.</p>
      </div>

      <div className={styles.layout}>

        {/* Formulario */}
        <div className={styles.formCard}>
          <h2 className={styles.formTitle}>Escríbenos</h2>

          {enviado && (
            <div className={styles.success}>
              ✅ ¡Mensaje enviado! Pronto te contactaremos.
            </div>
          )}

          <div className={styles.fields}>
            <input
              className={styles.input}
              type="text"
              name="nombre"
              placeholder="Nombre *"
              value={form.nombre}
              onChange={handleChange}
            />
            <input
              className={styles.input}
              type="email"
              name="email"
              placeholder="Correo Electrónico"
              value={form.email}
              onChange={handleChange}
            />
            <input
              className={styles.input}
              type="tel"
              name="telefono"
              placeholder="Teléfono"
              value={form.telefono}
              onChange={handleChange}
            />
            <textarea
              className={`${styles.input} ${styles.textarea}`}
              name="mensaje"
              placeholder="¿En qué podemos ayudarte? *"
              value={form.mensaje}
              onChange={handleChange}
              rows={5}
            />
          </div>

          <button
            className={styles.btn}
            onClick={handleEnviar}
            disabled={!form.nombre || !form.mensaje}
          >
            Enviar por WhatsApp
          </button>
        </div>

        {/* Datos de contacto */}
        <div className={styles.infoCard}>
          <h2 className={styles.infoTitle}>Contacto</h2>

          <div className={styles.infoList}>
            <div className={styles.infoItem}>
              <strong>TELÉFONO:</strong>
              <a href={`tel:${DATOS.telefono}`}>{DATOS.telefono}</a>
            </div>
            <div className={styles.infoItem}>
              <strong>CORREO ELECTRÓNICO:</strong>
              <a href={`mailto:${DATOS.email}`}>{DATOS.email}</a>
            </div>
            <div className={styles.infoItem}>
              <strong>DIRECCIÓN:</strong>
              <span>{DATOS.direccion}</span>
            </div>
          </div>

          <div className={styles.socials}>
            {/* WhatsApp */}
            <a href={`https://wa.me/${DATOS.whatsapp}`} target="_blank" rel="noopener noreferrer" className={styles.socialBtn} style={{ background: '#25d366' }}>
              <svg viewBox="0 0 24 24" fill="white" width="22" height="22">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </a>
            {/* Instagram */}
            <a href={DATOS.instagram} target="_blank" rel="noopener noreferrer" className={styles.socialBtn} style={{ background: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)' }}>
              <svg viewBox="0 0 24 24" fill="white" width="22" height="22">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}